import {
  TAGS_LIST_SUCCESS,
  TAGS_CREATE_SUCCESS,
  TAGS_UPDATE_SUCCESS,
  TAGS_DELETE_SUCCESS,
  SET_TAGS_SCOPE_FILTER,
  SET_TAGS_SEARCH_TEXT,
  SET_TAGS_VIEW_MODE,
} from "../actionTypes/tags";

const INIT_STATE = {
  tagsList: [],
  selectedScope: "all",
  searchText: "",
  viewMode: "listView", // "listView" or "gridView"
  queryInfo: { page: 1, size: 10 },
};

const deduplicateTags = (list) => {
  const map = new Map();
  (list || []).forEach((item) => {
    if (!item) return;
    const key = String(item._id || item.id || item.slug || Math.random());
    map.set(key, item);
  });
  return Array.from(map.values());
};

const tagsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TAGS_LIST_SUCCESS:
      return {
        ...state,
        tagsList: deduplicateTags(action.payload.tagsList),
        queryInfo: action.payload.queryInfo || state.queryInfo,
      };

    case TAGS_CREATE_SUCCESS:
      return {
        ...state,
        tagsList: deduplicateTags([action.payload, ...state.tagsList]),
      };

    case TAGS_UPDATE_SUCCESS:
      return {
        ...state,
        tagsList: deduplicateTags(
          state.tagsList.map((tag) =>
            (tag._id === action.payload._id || tag.id === action.payload.id || tag.slug === action.payload.slug)
              ? { ...tag, ...action.payload }
              : tag
          )
        ),
      };

    case TAGS_DELETE_SUCCESS:
      return {
        ...state,
        tagsList: state.tagsList.filter(
          (tag) => tag._id !== action.payload && tag.id !== action.payload && tag.slug !== action.payload
        ),
      };

    case SET_TAGS_SCOPE_FILTER:
      return {
        ...state,
        selectedScope: action.payload,
      };

    case SET_TAGS_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };

    case SET_TAGS_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload,
      };

    default:
      return state;
  }
};

export default tagsReducer;
